import { DEFAULT_STANDARD_RECORDING_TIME_HOURS } from '@bliks-io/contracts';
import { useOrgSettings } from '@/api/queries/useOrgSettings';

/**
 * Returns the org's standard recording time in milliseconds.
 * Falls back to the default (48h) if org settings aren't loaded yet.
 */
export function useStandardRecordingTimeMs(): number {
  const { data: settings } = useOrgSettings();
  return (
    (settings?.standardRecordingTime ?? DEFAULT_STANDARD_RECORDING_TIME_HOURS) * 60 * 60 * 1000
  );
}
